import { baseType, getItems, itemsPopUp } from "./items";

const numOfCells = 7;

const addOn = {
  Print: "print",
  Shop: "shop",
  PrintAndShop: "shopAndPrint",
};

const getBasics = (propertySize) => {
  switch (propertySize) {
    case "100-200":
      return [baseType.basic100];
    case "200-400":
      return [baseType.basic100, baseType.basic200];
    case "400-800":
      return [baseType.basic100, baseType.basic200, baseType.basic400];
    case "800+":
      return [
        baseType.basic100,
        baseType.basic200,
        baseType.basic400,
        baseType.basic800,
      ];
    default:
      return null;
  }
};
const isShop = (item) =>
  item?.type?.toLowerCase()?.includes("monitor")
    ? 0
    : item?.type === "shop"
    ? 1
    : 2;

export const getColumns = (collectDate, items) => {
  const _location =
    collectDate.country === "United States"
      ? "usa"
      : collectDate.country === "Israel"
      ? "israel"
      : "europe";

  let newArr = getItems(
    items,
    _location,
    collectDate.productsType,
    collectDate.property,
    collectDate.propertySize
  );

  const basic = [];
  let extras = [];
  let ride = [];

  for (let i = 0; i < newArr.length; i++) {
    const e = newArr[i];
    if (
      e.baseType &&
      getBasics(collectDate.propertySize).includes(
        e.baseType[collectDate.property]
      )
    ) {
      if (e.type === "system") {
      } else if (e.type === "ride") {
        ride.push(e);
      } else {
        basic.push(e);
      }
    } else {
      extras.push(e);
    }
  }

  // Filter population extra
  extras = extras.filter(
    (e) =>
      !e.population || e.population.some((r) => collectDate.people?.includes(r))
  );

  const { productsType } = collectDate;

  let newList = addExtraItems(
    basic,
    extras,
    Object.values(items),
    productsType
  );

  newList.sort(function (a, b) {
    if (a.category < b.category) {
      return -1;
    }
    if (a.category > b.category) {
      return 1;
    }
    return 0;
  });
  newList.sort((a, b) => a.ca - isShop(b));
  newList.sort((a, b) => isShop(a) - isShop(b));

  const numOfColumns = sumSize(newList) / numOfCells;

  const columns = [];

  for (let i = 0; i < numOfColumns; i++) {
    columns[i] = [];

    for (let j = 0; j < newList.length; j++) {
      if (newList[j]) {
        if (sumSize(columns[i]) + newList[j].cellSize <= numOfCells) {
          columns[i].push(newList[j]);
          delete newList[j];

          if (sumSize(columns[i]) === numOfCells) {
            columns[i].sort((a, b) => a.cellSize - b.cellSize);
            columns[i].sort((a, b) => a.position - b.position);
            break;
          }
        }
      }
    }
  }
  return { columns, ride };
};

const addExtraItems = (arr, extras, allItems, type) => {
  // if (type.includes("shop") && type.includes("printer")) {
  //   type = addOn.PrintAndShop
  // } else if (type.includes("shop")) {
  //   type = addOn.Shop
  // }
  if (type.includes("printer")) {
    type = addOn.Print;
  }

  // addOn.PrintAndShop

  const newArr = [...arr];
  let biggerThenMaxCell = newArr.findIndex((e) => e.cellSize > numOfCells);

  while (biggerThenMaxCell > -1) {
    newArr.splice(biggerThenMaxCell, 1);
    biggerThenMaxCell = newArr.findIndex((e) => e.cellSize > numOfCells);
  }

  // newArr.splice(0, 1)

  newArr.sort((a, b) => b.cellSize - a.cellSize);
  newArr.sort((a, b) => a.category - b.category);

  if (type === "shop") {
    newArr.splice(1, 0, itemsPopUp.shop);
  } else if (type === "print") {
    newArr.splice(5, 0, itemsPopUp.printer);
  } else if (type === "shopAndPrint") {
    newArr.splice(1, 0, itemsPopUp.shop);
    newArr.splice(5, 0, itemsPopUp.printer);
  }

  const needExtraSize =
    sumSize([itemsPopUp.monitor, ...newArr]) % numOfCells === 0
      ? 0
      : numOfCells - (sumSize([itemsPopUp.monitor, ...newArr]) % numOfCells);

  extras.sort((a, b) => a.extraOrder || 0 - b.extraOrder || 0);
  const extra = [];
  extras.forEach((i) => {
    if (i.cellSize + sumSize(extra) <= needExtraSize) {
      extra.push(i);
    }
  });

  if (extra.length < needExtraSize) {
    allItems.forEach((i) => {
      if (
        i.cellSize + sumSize(extra) <= needExtraSize &&
        ![itemsPopUp.monitor, ...newArr, ...extra].includes(i.id)
      ) {
        extra.push(i);
      }
    });
  }

  return [itemsPopUp.monitor, ...newArr, ...extra];
};

const sumSize = (arr) => {
  return arr.reduce((sum, item) => sum + parseFloat(item.cellSize || 0), 0);
};
